import { Skeleton } from '@heroui/react';

import {
  AgentExecutionKeyCell,
  AgentExecutionKeyCellSkeleton,
  AgentNameCell,
  AgentNameCellSkeleton,
  PipelineKeyCell,
  PipelineKeyCellSkeleton
} from './components/cells';
import type { AgentLogsTableRow } from '../../types';

import type { RenderCellProps } from '~/components/Table/Table';
import {
  LogMessageCell,
  LogMessageCellSkeleton,
  PipelineNameCell,
  PipelineNameCellSkeleton,
  TimestampCell,
  TimestampCellSkeleton
} from '~/scenes/Monitor/scenes/PipelineLogs/components/cells';

type CellRenderer = {
  render: (item: AgentLogsTableRow) => JSX.Element;
  skeleton: () => JSX.Element;
};

const CELL_RENDERERS: Record<string, CellRenderer> = {
  timestamp: {
    render: item => <TimestampCell timestamp={item.timestamp} />,
    skeleton: () => <TimestampCellSkeleton />
  },
  agentName: {
    render: item => <AgentNameCell agentName={item.agentName} />,
    skeleton: () => <AgentNameCellSkeleton />
  },
  agentExecutionKey: {
    render: item => (
      <AgentExecutionKeyCell agentExecutionKey={item.agentExecutionKey} />
    ),
    skeleton: () => <AgentExecutionKeyCellSkeleton />
  },
  pipelineName: {
    render: item => (
      <PipelineNameCell
        pipelineName={item.pipelineName}
        pipelineVersion={item.pipelineVersion}
      />
    ),
    skeleton: () => <PipelineNameCellSkeleton />
  },
  pipelineKey: {
    render: item => <PipelineKeyCell pipelineKey={item.pipelineKey} />,
    skeleton: () => <PipelineKeyCellSkeleton />
  },
  contentPreview: {
    render: item => <LogMessageCell logMessage={item.contentPreview} />,
    skeleton: () => <LogMessageCellSkeleton />
  }
};

export function renderCell({
  item,
  columnKey,
  isLoading
}: RenderCellProps<AgentLogsTableRow>) {
  const renderer = CELL_RENDERERS[columnKey as string];

  if (!renderer) {
    return isLoading ? <Skeleton className='h-4 w-20 rounded' /> : null;
  }

  return isLoading ? renderer.skeleton() : renderer.render(item);
}
